/*
 * What the server's state says of v31's systems, where it says anything
 * (a v30 server says nothing, and none of it shows): the army's steel
 * upkeep, command points, and whether trained designs need a camp.
 */

import { createSignal } from "solid-js";

export interface Upkeep {
  /** Steel a minute (a tenth of each unit's build steel an hour). */
  perMin: number;
  /** The last minute's went unpaid: barracks wait until it's paid. */
  unpaid: boolean;
}

export interface Command {
  capacity: number;
  used: number;
  /** Members a point (50). */
  perPoint: number;
  /** Formations over capacity (holding, taking no orders), by id. */
  uncommanded: Set<number>;
  /** Where each held formation is (its centre hex), when the server says. */
  at: [number, number][];
}

const [upkeep, setUpkeep] = createSignal<Upkeep | null>(null);
/** Your finished training camps and comms posts (they make no depot, so
 *  frames don't show them). */
let camps: [number, number][] = [];
let posts: [number, number][] = [];
export const ownCamps = () => camps;
export const ownPosts = () => posts;
const [command, setCommand] = createSignal<Command | null>(null);
export { upkeep, command };

/** The reach of a training camp, in hexes (construction::TRAINING_CAMP_REACH). */
export const CAMP_REACH = 12;

/** v31's systems are there (the server sends command points): training
 *  camps, comms posts and steel upkeep with them. */
export const v31 = () => command() !== null;

export function setFeatures(state: Record<string, unknown>): void {
  const cons = state.construction as { camps?: [number, number][]; comms_posts?: [number, number][] } | undefined;
  camps = cons?.camps ?? [];
  posts = cons?.comms_posts ?? [];
  const u = state.upkeep as { steel_per_min?: number; steel_unpaid?: boolean } | undefined;
  setUpkeep(u && typeof u.steel_per_min === "number" ? { perMin: u.steel_per_min, unpaid: !!u.steel_unpaid } : null);
  const c = state.command as { capacity?: number; used?: number; per_point?: number; uncommanded?: number[]; uncommanded_at?: [number, number][] } | undefined;
  const next = c && typeof c.capacity === "number" ? { capacity: c.capacity, used: c.used ?? 0, perPoint: c.per_point ?? 50, uncommanded: new Set(c.uncommanded ?? []), at: c.uncommanded_at ?? [] } : null;
  const was = command();
  // Unchanged: no new object (nothing downstream redraws).
  if (was && next && was.capacity === next.capacity && was.used === next.used && [...was.uncommanded].join() === [...next.uncommanded].join() && was.at.join() === next.at.join()) return;
  setCommand(next);
}
